/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free GC skew plotter. Visualise (G−C)/(G+C) in sliding windows along a DNA sequence, plus cumulative skew, to help locate replication origins and terminals.`)
};

const es_gcskew_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graficador gratuito de sesgo GC. Visualiza (G−C)/(G+C) en ventanas deslizantes a lo largo de una secuencia de ADN, más el sesgo acumulado, para ayudar a localizar orígenes y terminales de replicación.`)
};

const de_gcskew_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser GC-Skew-Plotter. Visualisieren Sie (G−C)/(G+C) in gleitenden Fenstern entlang einer DNA-Sequenz sowie den kumulativen Skew, um Replikationsursprünge und -termini zu lokalisieren.`)
};

const nl_gcskew_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis GC-skewplotter. Visualiseer (G−C)/(G+C) in schuivende vensters langs een DNA-sequentie, plus cumulatieve skew, om replicatie-oorsprongen en -eindpunten te helpen lokaliseren.`)
};

const fr_gcskew_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traceur gratuit de biais GC. Visualisez (G−C)/(G+C) dans des fenêtres glissantes le long d'une séquence d'ADN, ainsi que le biais cumulé, pour aider à localiser les origines et terminaisons de réplication.`)
};

const it_gcskew_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafico gratuito dello skew GC. Visualizza (G−C)/(G+C) in finestre scorrevoli lungo una sequenza di DNA, oltre allo skew cumulativo, per aiutare a localizzare le origini e i termini di replicazione.`)
};

const pt_br2_gcskew_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plotador gratuito de GC skew. Visualize (G−C)/(G+C) em janelas deslizantes ao longo de uma sequência de DNA, além do skew acumulado, para ajudar a localizar origens e terminais de replicação.`)
};

const pt_gcskew_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráfico gratuito de assimetria GC. Visualize (G−C)/(G+C) em janelas deslizantes ao longo de uma sequência de ADN, mais a assimetria cumulativa, para ajudar a localizar as origens e os términos de replicação.`)
};

const ja_gcskew_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のGCスキュープロッター。DNA配列に沿った移動窓内の(G−C)/(G+C)と累積スキューを可視化し、複製起点と終結点の特定に役立てます。`)
};

const zh_gcskew_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 GC 偏斜绘图工具。以滑动窗口方式可视化 DNA 序列中的 (G−C)/(G+C)，并显示累积偏斜，有助于定位复制起点和终点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_meta_description", locale)
	if (locale === "en") return en_gcskew_meta_description(inputs)
	if (locale === "es") return es_gcskew_meta_description(inputs)
	if (locale === "de") return de_gcskew_meta_description(inputs)
	if (locale === "nl") return nl_gcskew_meta_description(inputs)
	if (locale === "fr") return fr_gcskew_meta_description(inputs)
	if (locale === "it") return it_gcskew_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_meta_description(inputs)
	if (locale === "pt") return pt_gcskew_meta_description(inputs)
	if (locale === "ja") return ja_gcskew_meta_description(inputs)
	return zh_gcskew_meta_description(inputs)
};